import {BaseCL} from "./BaseCL";
import {UiFlashMessage, UiLoaderItem} from "./UiFlashMessage";
import {AnyElement} from "mu-widget/lib/MuWidget";

export class MyBaseCL extends BaseCL {
	protected message: string|null = null;

	public loadingElement: HTMLElement|null = null;

	constructor(url : string) {
		super();
		this.url = url;
		this.onLoading = () => {
			this.loadingElement?.classList.toggle('loading-data', true);
			const fm = UiFlashMessage.instance.add(this.message ?? "Komunikuji se serverem.", "loader");
			return fm;
		};
		this.onLoaded = (l : UiLoaderItem) => {
			this.loadingElement?.classList.toggle('loading-data', false);
			l.remove();
		};
	}

	public withMessage(message: string, loadingElement: HTMLElement|AnyElement|AnyElementA|null = null): this
	{
		const newCl = new (this as any).constructor(this.url);
		newCl.message = message;
		(newCl as unknown as any).loadingElement = loadingElement;
		newCl.context = this.context;
		return newCl;
	}

	protected override updateContext(context: any): any {
		if (context.flashMessages) {
			for(const flashMessage of context.flashMessages)
				UiFlashMessage.instance.add(flashMessage);
		}
		return super.updateContext(context);
	}

	public async loadRawData(url: string, data: any|null = null): Promise<string|null>
	{
		const fopt: RequestInit = {};
		if (data) {
			fopt.body = data;
			fopt.method = "POST";
		}
		const f = fetch(url, fopt);
		let loadingHandle = null;
		let response = null;
		try {
			if (this.onLoading) loadingHandle = this.onLoading(url);
			response = await (await f).text();
		} catch (exc) {
			throw exc;
		} finally {
			if (this.onLoaded) this.onLoaded(loadingHandle, response);
		}

		return response;
	}
}
